import { render, staticRenderFns } from "./AccountsButton.vue?vue&type=template&id=3cda9a7f"
import script from "./AccountsButton.vue?vue&type=script&lang=ts"
export * from "./AccountsButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports